import { render, staticRenderFns } from "./modifyPrice.vue?vue&type=template&id=128c475e&scoped=true&"
import script from "./modifyPrice.vue?vue&type=script&lang=js&"
export * from "./modifyPrice.vue?vue&type=script&lang=js&"
import style0 from "./modifyPrice.vue?vue&type=style&index=0&id=128c475e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128c475e",
  null
  
)

export default component.exports